import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import {
  IServiceConfigItem,
  IServiceConfigUpdateParam,
  IAuthFailItem,
  IUserListItem,
  IUserOnlineItem,
  IGameListItem,
  IAuthSyncReqItem,
  IAuthSyncSureItem,
  IAPIApproveItem,
  IAPIServiceConfigItem,
  IAPIServicesOpenItem,
  CommonStatusStep,
  IAPIGameServicesOpenItem,
  IConfigEnvRegion,
} from '../../model/api-modules';
import {
  IEnvService,
  IServiceBatchApproval,
  ISyncServiceConfig,
} from '../../model/api-modules/env';
import { ADMIN_PREFIX, ADMIN_INGAME_CONSOLE_PROXY_PREFIX } from '../config';
import { ICosCredential } from '../../pages/admin/upload-cos/model';
import { messageError } from '../../components/message';

// 获取服务审批-列表
export const getServiceApprovalList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/approval/list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIApproveItem>(response, 'data');
      // return res;
      // return res.list
      //   .sort((a, b) => (a.CreateTime > b.CreateTime ? -1 : 1))
      //   .sort((a, b) => (b.Status > a.Status ? -1 : 1));
      return {
        list: res.list
          .sort((a, b) => (a.CreateTime > b.CreateTime ? -1 : 1))
          .sort((a, b) => (b.Status > a.Status ? -1 : 1)),
        gameList: res.gameList,
      };
    } catch (error) {
      return null;
    }
  });

// 服务开通-列表-<包括已下线服务>,Status: 已开通:1, 拒绝：2 --admin侧
export const serviceAdminOpenList = (gameID: string, envID: Number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/opened-status?gameID=${gameID}&envID=${envID}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIServicesOpenItem[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return [];
    }
  });

export const serviceAdminOpenListByGame = (gameID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/opened-list/${gameID}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIGameServicesOpenItem[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return [];
    }
  });

export const offlineOldService = (body: {
  gameID: string;
  envID: Number;
  serviceID: Number;
  subServiceName: string;
  status: CommonStatusStep;
}) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/offline`;
      const res = await api.commonRequest('POST', url, body);
      await parsedResponse<IAPIresponse>(res, 'data');
      return true;
    } catch (error) {
      return false;
    }
  });
// 服务配置-列表---admin侧
export const getAdminServiceList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIServiceConfigItem[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return null;
    }
  });

export const deleteServiceApi = (name: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/config/${name}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return false;
    }
  });

// 服务管理-服务审批-审批
export const putServiceApproval = (
  id: Number,
  status: Number,
  expectedAmount = 0,
  rejectReason = ''
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/approval/${id}/${status}`;
      const response = await api.commonRequest('PUT', url, {
        expectedAmount,
        rejectReason,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 服务管理-服务审批-批量审批
export const putServiceBatchApproval = (body: IServiceBatchApproval) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/batch-approval`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error: any) {
      return error?.apiError;
    }
  });

// 服务管理-服务审批-获取版本号
export const getBatchApprovalVersion = (
  gameId: string,
  envId: string,
  projectName: string,
  repoName: string,
  chartName: string,
  g6DomainURL: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_INGAME_CONSOLE_PROXY_PREFIX}/v1/api/ingame-oms/bcs_helm_manager/chart_versions?gameID=${gameId}&envID=${envId}&devops_project_eng_name=${projectName}&repo_name=${repoName}&chart_name=${chartName}&g6DomainURL=${encodeURIComponent(
        g6DomainURL
      )}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 服务管理-服务审批-获取环境region
export const getEnvRegion = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/dictionary/config?key=config_env_region`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IConfigEnvRegion>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

//  服务管理-服务审批-G6部署
export const g6Arrange = (body: IEnvService) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/approval/notify-om`;
      const response = await api.commonRequest('PATCH', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

//  服务管理-服务审批-下线
export const closeService = (id: Number, status: Number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/patch-status/${id}/${status}`;
      const response = await api.commonRequest('PATCH', url);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 服务管理-服务配置-创建
export const postServiceConfig = (body: IServiceConfigItem) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/config`;
      const response = await api.commonRequest('POST', url, body);
      await parsedResponse<IAPIresponse>(response, 'data');
      return true;
    } catch (error) {
      return null;
    }
  });

// 服务管理-服务审批-修改
export const putServiceConfig = (body: IServiceConfigUpdateParam) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/config/${body.id}`;
      const response = await api.commonRequest('PUT', url, {
        Status: body.Status,
        Name: body.Name,
        Business: body.Business,
        SupportType: body.SupportType,
        ParentName: body.ParentName,
        IconURL: body.IconURL,
        Sort: body.Sort,
        Pic: body.Pic,
        ParentSort: body.ParentSort,
        ServicePath: body.ServicePath,
        JsonConfig: body.JsonConfig,
        ReleaseSort: body.ReleaseSort,
        SubServiceNames: body.SubServiceNames,
        UniqueName: body.UniqueName,
      });
      await parsedResponse<IAPIresponse>(response, 'data');
      return true;
    } catch (error) {
      return null;
    }
  });

// Gauth-失败记录展示
export const getGauthFailList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/auth-sync/fail-list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAuthFailItem[]>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// Gauth-失败列表-重试
export const failRetryList = async (
  id: number,
  userID: Array<string>
): Promise<IAuthSyncReqItem[]> => {
  try {
    const url = `${ADMIN_PREFIX}/service/auth-sync/fail-retry/${id}`;
    const response = await withAPIAccount(AccountType.auto, (api) =>
      api.commonRequest('POST', url, { userID })
    );
    const res = await parsedResponse<IAuthSyncReqItem[]>(response, 'data');
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Gauth-失败记录重试前名单展示确认
export const getFailSureList = (id: Number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/auth-sync/retry-user/${id}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAuthSyncSureItem>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 用户-获取列表(取Pic对应的用户ID)
export const getUserIdList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/user`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IUserListItem[]>(response, 'data');
      return res;
    } catch (error) {
      return [];
    }
  });

// 用户-获取在线状态
export const getOnlineStatus = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/user/online-record`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IUserOnlineItem[]>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 用户-踢用户下线
export const kickOnline = (UserID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/user/kick-online/${encodeURIComponent(
        UserID
      )}`;
      const response = await api.commonRequest('POST', url);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

// 后台辅助开通服务--已经下线
// export const openGameService = (gameID: string) =>
//   post<IUserListItem[]>(`${ADMIN_PREFIX}/service/temp-opened/${gameID}`);

// 获取游戏列表
export const getGames = (studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/game/list`;
      const response = await api.commonRequest('GET', url, { studioID });
      const res = await parsedResponse<IGameListItem[]>(response, 'data');
      return res;
    } catch (error) {
      return [];
    }
  });

// 获取临时凭证
export const getCosCredentialApi = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/download-center/cos/sts`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ICosCredential>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });

//  服务配置同步
export const syncServiceConfig = (body: ISyncServiceConfig) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/service/approval/notify-om`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      return null;
    }
  });
